<template>

  <div id="companies">

    <div class="top-buttons">
      <button class="btn btn-primary" v-show="!showDeleted" @click="showDeleted = true">{{$t('companies.show_deleted')}}</button>
      <button class="btn btn-primary" v-show="showDeleted" @click="showDeleted = false">{{$t('companies.show_non_deleted')}}</button>
    </div>

    <Datatable
      entity="company"
      class="datatable"
      ref="datatable"
      :onRowClick="onRowClick"
      :parameters="{branch: $route.query.branch, deleted: showDeleted}"
      :globalActions="isDistributor ? [] : [
        {text: 'companies.new', method: onCompanyCreate},
        {text: 'companies.new_user', method: onBranchUserCreate},
        {text: 'companies.manage_display_priority', method: onManageDisplayPriority}
      ]"
      :rowActions="isDistributor ? [] : [
        {text: 'datatable.edit', method: onRowEdit},
        {text: 'datatable.disable', method: onRowDisable, condition: r => r.active},
        {text: 'datatable.enable', method: onRowEnable, condition: r => !r.active},
        {text: 'datatable.delete', method: onRowDelete}
      ]"
    />

    <Modal
      name="confirmation"
      :title="$t('branches.confirmation')"
      dismissable
      :actions="[{name: $t('back'), action: 'close'}, {name: confirmationActionName, action: confirmationAction, primary: true}]">
      <p v-html="confirmationHtml"/>
      <input type="text" class="w-100" v-model="confirmationText">
    </Modal>

  </div>

</template>

<script>

  import Datatable from "@/components/Datatable.vue";
  import { mapActions } from 'vuex';

  export default {

    name: 'companies',

    components: {Datatable},

    data() {
      return {
        actionRow: {},
        errorKey: "",
        confirmationText: "",
        confirmationActionName: "",
        confirmationAction: "",
        confirmationHtml: "",
        confirmationModel: "",
        showDeleted: false
      }
    },

    computed: {
      isDistributor() {
        return this.$store.state.loggedUser.isDistributor
      }
    },

    mounted() {
      if (!this.$store.getters.loggedUserHasBranchAdmin) {
        this.$router.replace("/categories?branch=" + this.$store.state.loggedUser.branch
          + "&company=" + this.$store.state.loggedUser.company);
        return;
      }
      this.$store.state.pageTitleTranslationKey = "";
      this.$store.state.pageIcon = "/icon/branches.svg";
    },

    methods: {

      ...mapActions(["deleteCompany", "saveCompany"]),

      onCompanyCreate() {
        this.$router.push("/company/new?branch=" + this.$route.query.branch);
      },

      onRowClick(row) {
        this.$router.push(this.$router.buildContext("/categories", {company: row.id}));
      },

      onRowEdit(row) {
        this.$router.push(this.$router.buildContext("/company/edit", {company: row.id}));
      },

      onRowDelete(row) {
        this.actionRow = row;
        this.confirmationActionName = this.$t('datatable.delete');
        this.confirmationAction = this.deleteCompanyCallback;
        this.confirmationHtml = this.$t('companies.delete_p1') + this.actionRow.name + this.$t('companies.delete_p2');
        this.confirmationText = "";
        this.$modal.show("confirmation");
      },

      onBranchUserCreate() {
        this.$router.push("/user/new?branch=" + this.$route.query.branch);
      },

      onManageDisplayPriority() {
        this.$router.push(`/branch/company-priority?branch=${this.$route.query.branch}`);
      },

      onRowDisable(row) {
        this.actionRow = row;
        this.confirmationActionName = this.$t('datatable.disable');
        this.confirmationAction = this.toggleCompanyEnabled;
        this.confirmationHtml = this.$t('companies.disable_p1') + this.actionRow.name + this.$t('companies.disable_p2');
        this.confirmationText = "";
        this.$modal.show("confirmation");
      },

      onRowEnable(row) {
        this.actionRow = row;
        this.confirmationActionName = this.$t('datatable.enable');
        this.confirmationAction = this.toggleCompanyEnabled;
        this.confirmationHtml = this.$t('companies.enable_p1') + this.actionRow.name + this.$t('companies.enable_p2');
        this.confirmationText = "";
        this.$modal.show("confirmation");
      },

      async toggleCompanyEnabled() {
        if (this.confirmationText.toLowerCase() !== this.actionRow.name.toLowerCase()) {
          this.errorKey = "companies.error.disable_no_match";
          this.$modal.show("error");
          return;
        }
        this.$store.commit("showSpinner", true);
        let response = await this.saveCompany({
          branchId: this.$route.query.branch,
          companyId: this.actionRow.id,
          data: {active: !this.actionRow.active, deleted: this.actionRow.active ? this.actionRow.deleted : false}
        });
        if (response) {
          this.$modal.show("confirmation", false);
          this.$refs.datatable.query();
          this.$store.commit("showSpinner", false);
        } else {
          this.$store.commit("showSpinner", false);
          this.errorKey = "error.no_server";
          this.$modal.show("error");
        }
      },

      async deleteCompanyCallback() {
        if (this.confirmationText.toLowerCase() !== this.actionRow.name.toLowerCase()) {
          this.errorKey = "companies.error.delete_no_match";
          this.$modal.show("error");
          return;
        }
        this.$store.commit("showSpinner", true);
        let response = await this.deleteCompany({companyId: this.actionRow.id, branchId: this.$route.query.branch});
        if (response) {
          this.$modal.show("confirmation", false);
          this.$refs.datatable.query();
          this.$store.commit("showSpinner", false);
        } else {
          this.$store.commit("showSpinner", false);
          this.errorKey = "error.no_server";
          this.$modal.show("error");
        }
      }
    }
  };

</script>


<style lang="scss" scoped>
  .datatable {
    height: 100%;
  }
  .top-buttons {
    margin-bottom: 10px;
    text-align: right;
  }
</style>